/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teen_Setting_DescriptionInputs */

const fr_teen_setting_description = /** @type {(inputs: Teen_Setting_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de cours adultes par mois qu'un ado peut suivre avec un parent inscrit au même cours.`)
};

/**

* @param {Teen_Setting_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const teen_setting_description = /** @type {((inputs?: Teen_Setting_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teen_Setting_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_teen_setting_description(inputs)
});